export default "__VITE_ASSET__DULtETa4__"